<script>
import NextMixinListPage from "@/components/mixins/NextMixinListPage";
import MixinActions from "@/components/mixins/MixinListActions";
import MixinList from './MixinList';
import ActivateGiftCard from './ActivateGiftCard.vue'
import MovimientosTarjeta from './MovimientosTarjeta.vue'
import SaldosTarjetas from './SaldosTarjetas.vue'
import * as templateDesktop from "./GiftCardListDesktop.vue?vue&type=template";
import * as templateMobile from "./GiftCardListMobile.vue?vue&type=template";
import ModalShow from "./ModalShow.vue";
import AppMenu from "../menu/AppMenu.vue";

let render = templateDesktop.render;
if (window.innerWidth < 960) {
  render = templateMobile.render;
}

export default {
  mixins: [NextMixinListPage, MixinActions, MixinList],
  components: { ModalShow, ActivateGiftCard, MovimientosTarjeta, SaldosTarjetas, AppMenu },
  render: render,
  data() {
    return {
      title: "Tarjetas Compradas",
      form: {},
      url: "api/v1/gift-card",
      pathBase: "/inventory/gift-card",
      pathCreate: "/inventory/gift-card/create",
      options: {
        page: 1,
        itemsPerPage: 10,
        itemsPerPageOptions: [10, 25, 50, 100],
        sortBy: ['created_at'],
        sortDesc: [true]
      },
      
      headers: [
        { title: "num", value: "index", sortable: false },
        { title: "code", value: "code", sortable: true, class: "th-code", cellClass: "td-code" },
        { title: "status", value: "status", sortable: true, class: "th-status", cellClass: "td-status" },
        { title: "amount", value: "amount", sortable: true, class: "th-amount", cellClass: "td-amount" },
        { text: "Saldo", title: "saldo", value: "saldo", sortable: false },
        { title: "expiration_date", value: "expiration_date", sortable: true, class: "th-expiration_date", cellClass: "td-expiration_date" },
        { title: "activation_date", value: "activation_date", sortable: true, class: "th-activation_date", cellClass: "td-activation_date" },
        { title: "invoice", value: "invoice", sortable: false, class: "th-invoice", cellClass: "td-invoice" },
        { title: "user_created", value: "user_created", sortable: false, class: "th-user_created", cellClass: "td-user_created" },
        { title: "created_at", value: "created_at", sortable: true, class: "th-created_at", cellClass: "td-created_at" },
        { title: "_actions", value: "_actions", sortable: false }
      ],
          };
  },
  methods: {
    breadcrumbsInit() {
        this.breadcrumbs = [
            { text: this.$t('Inicio'), disabled: false, to: '/pos', 'exact-path': true },
            { text: this.$t('Tarjetas Compradas'), disabled: false, to: '/pos/gift-card', 'exact-path': true },
            { text: this.$t('gift-card-list'), disabled: true, to: '', 'exact-path': true },
        ];
    },
  },
};
</script>
